<app-settings-base
  title="{{'chamberOfCommerceSettings.title' | translate}}"
  description="{{'chamberOfCommerceSettings.text' | translate}}"
  details="{{'chamberOfCommerceSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/chamber-of-commerce">
</app-settings-base>
